import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VideojsWavesurferComponent } from '../common/videojs-wavesurfer/videojs-wavesurfer.component';
import { AuditDetailsComponent } from './audits/audit-details/audit-details.component';
import { AuditsComponent } from './audits/audits.component';
import { AiAuditsComponent } from './ai-audits/ai-audits.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { NewCampaignComponent } from './campaigns/new-campaign/new-campaign.component';
import { ViewCampaignDetailsComponent } from './campaigns/view-campaign-details/view-campaign-details.component';
import { ConsoleComponent } from './console.component';
import { GroupDetailsComponent } from './groups/group-details/group-details.component';
import { GroupsComponent } from './groups/groups.component';
import { HistoricalmetricDetailsComponent } from './historicalmetrics/historicalmetric-details/historicalmetric-details.component';
import { HistoricalmetricsComponent } from './historicalmetrics/historicalmetrics.component';
import { InteractionDetailsComponent } from './interactions/interaction-details/interaction-details.component';
import { AiInteractionDetailsComponent } from './ai-interactions/ai-interaction-details/ai-interaction-details.component';
import { InteractionsComponent } from './interactions/interactions.component';
import { IvrDetailsComponent } from './ivrs/ivr-details/ivr-details.component';
import { IvrsComponent } from './ivrs/ivrs.component';
import { LivestatusDetailsComponent } from './livestatuses/livestatus-details/livestatus-details.component';
import { LivestatusesComponent } from './livestatuses/livestatuses.component';
import { QueueDetailsComponent } from './queues/queue-details/queue-details.component';
import { QueuesComponent } from './queues/queues.component';
import { SkillDetailsComponent } from './skills/skill-details/skill-details.component';
import { SkillsComponent } from './skills/skills.component';
import { VoicemailDetailsComponent } from './voicemails/voicemail-details/voicemail-details.component';
import { VoicemailsComponent } from './voicemails/voicemails.component';
import { AiInteractionsComponent } from './ai-interactions/ai-interactions.component';
import { KnowledgeDocsComponent } from './knowledge-docs/knowledge-docs.component';

const routes: Routes = [
  { path: '', component: ConsoleComponent },
  { path: 'Queues', component: QueuesComponent },
  { path: 'Skills', component: SkillsComponent },
  { path: 'Groups', component: GroupsComponent },
  { path: 'Agents/LiveStatuses', component: LivestatusesComponent },
  { path: 'Agents/HistoricalMetrics', component: HistoricalmetricsComponent },
  { path: 'Voicemails', component: VoicemailsComponent },
  { path: 'Campaigns', component: CampaignsComponent },
  { path: 'IVR', component: IvrsComponent },
  { path: 'Interactions', component: InteractionsComponent },
  { path: 'Auditing/Interactions', component: InteractionsComponent },
  { path: 'Auditing/AIInteractions', component: AiInteractionsComponent },
  { path: 'Auditing/Audits', component: AuditsComponent },
  { path: 'Auditing/AIAudits', component: AiAuditsComponent },
  { path: 'video', component: VideojsWavesurferComponent },
  {path: 'Knowledge-docs', component: KnowledgeDocsComponent},

  {
    path: 'Queues/Details/:id',
    pathMatch: 'prefix',
    component: QueueDetailsComponent,
  },
  {
    path: 'Skills/Details/:id',
    pathMatch: 'prefix',
    component: SkillDetailsComponent,
  },
  {
    path: 'Groups/Details/:id',
    pathMatch: 'prefix',
    component: GroupDetailsComponent,
  },

  {
    path: 'Agents/LiveStatuses/Details/:id',
    pathMatch: 'prefix',
    component: LivestatusDetailsComponent,
  },
  {
    path: 'Agents/HistoricalMetrics/Details/:id',
    pathMatch: 'prefix',
    component: HistoricalmetricDetailsComponent,
  },
  {
    path: 'Voicemails/Details/:id',
    pathMatch: 'prefix',
    component: VoicemailDetailsComponent,
  },
  {
    path: 'Campaigns/New',
    pathMatch: 'prefix',
    component: NewCampaignComponent,
  },
  {
    path: 'Campaigns/View-Details/:id',
    pathMatch: 'prefix',
    component: ViewCampaignDetailsComponent,
  },
  {
    path: 'Campaigns/Details/:id',
    pathMatch: 'prefix',
    component: NewCampaignComponent,
  },
  {
    path: 'IVR/Details/:id',
    pathMatch: 'prefix',
    component: IvrDetailsComponent,
  },
  {
    path: 'Interactions/Details/:id',
    pathMatch: 'prefix',
    component: InteractionDetailsComponent,
  },
  {
    path: 'Auditing/Interactions/Details/:id',
    pathMatch: 'prefix',
    component: InteractionDetailsComponent,
  },
  {
    path: 'Auditing/AIInteractions/:id',
    pathMatch: 'prefix',
    component: AiInteractionDetailsComponent,
  },
  {
    path: 'Auditing/Audits/Details/:id',
    pathMatch: 'prefix',
    component: AuditDetailsComponent,
  },
  {
    path: 'Console/Queues/Details/:id',
    pathMatch: 'prefix',
    component: QueueDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConsoleRoutingModule {}
